import store from '../store'
import BaseRepository from '@/repository/BaseRepository'

export default class VATRepository extends BaseRepository {
  async getAll() {
    return this.get('/vat').then((response) => {
      store.commit('updateVatGroups', response.data.items)
    })
  }
}